import React, { forwardRef, useState, useImperativeHandle } from 'react';
import 'emoji-mart/css/emoji-mart.css';
import { Picker } from 'emoji-mart';
import $ from "jquery";

export const EmojiPicker = forwardRef((props, ref) => {

    const [showPicker, setShowPicker] = useState(false);

    useImperativeHandle(ref,
        () => ({
            showEmojiPicker() {
                setShowPicker(true);
            }
        })
    );


    //MANAGE DISPLAYING ACTION
    $(document).click(function (e) {
        (e.target.id !== "emoji-picker-container"
            && $(e.target).parents(`#emoji-picker-container`).length === 0
            && (e.target.id !== props.showerId
                && $(e.target).parents(`#${props.showerId}`).length === 0))
            && setShowPicker(false);
    });

    return (
        <>
            {
                showPicker &&
                <div id="emoji-picker-container" style={{ position: "absolute", bottom: 0, right: 50 }}>
                    <Picker title="Pick your emoji... " onSelect={(skin) => props.callbackfn(skin.native)} />
                </div>
            }
        </>
    );
});